import type { NavigationUrls } from 'types';

export const INTERNAL_LOGIN_PATH = '/login';
export const EXTERNAL_LOGIN_PATH = '/login-external';

export const getRecordDetailUrl = (urls: NavigationUrls, recordId: string): string => {
  const { moduleId, systemType, agendaId } = urls;
  return `/user/modules/${moduleId}/${systemType}/${agendaId}/r/${recordId}/detail`;
};

export const getAgendaListUrl = (urls: NavigationUrls): string => {
  const { moduleId, systemType, agendaId } = urls;
  return `/user/modules/${moduleId}/${systemType}/${agendaId}`;
};

export const getEditRecordUrl = (urls: NavigationUrls, recordId: string): string => {
  const { moduleId, systemType, agendaId } = urls;
  return `/user/modules/${moduleId}/${systemType}/${agendaId}/r/${recordId}`;
};

export const getHeliosRecordDetailUrl = (moduleId: string, templateId: string, recordNumber: number | string): string => {
  return `/user/modules/${moduleId}/Helios/${templateId}/r/${recordNumber}/detail`;
};

const decodePathname = (pathname: string): string | null => {
  try {
    return decodeURIComponent(pathname);
  } catch {
    return null;
  }
};

export const isSharedPath = (pathname: string): boolean => {
  const normalizedPath = decodePathname(pathname);

  if (normalizedPath === null) {
    return false;
  }

  return normalizedPath === '/shared' || normalizedPath.startsWith('/shared/');
};

export const isLoginPath = (pathname: string): boolean => {
  const normalizedPath = decodePathname(pathname);

  if (normalizedPath === null) {
    return false;
  }

  const pathWithoutTrailingSlash = normalizedPath.replace(/\/$/, '');

  return pathWithoutTrailingSlash === INTERNAL_LOGIN_PATH || pathWithoutTrailingSlash === EXTERNAL_LOGIN_PATH;
};

export const getUnauthenticatedLoginPath = (pathname: string): string => {
  if (isSharedPath(pathname) || decodePathname(pathname)?.replace(/\/$/, '') === EXTERNAL_LOGIN_PATH) {
    return EXTERNAL_LOGIN_PATH;
  }

  return INTERNAL_LOGIN_PATH;
};
